/**
 * @fileoverview Component for displaying a site card.
 * This component includes a header with tabs and a content area for displaying the site details.
 */

import { Outlet, useLoaderData, useLocation } from 'react-router-dom'
import BackIcon from '../../assets/back.svg'
import SitesIcon from '../../assets/menu/sites.svg'
import Tabs from '../elements/Tabs'

/**
 * @function SiteCard
 * @description Component for displaying a site card.
 * @returns {JSX.Element} - A React component that renders the site card.
 */
export function SiteCard() {
    const location = useLocation()
    const tab = location.pathname.split('/').pop()
    const { site } = useLoaderData() as { site: Novoic.API.Site }

    return (
        <section>
            <section className="bg-white sticky top-0 w-full divide-y divide-gray-200 border-b-gray-200 border-b">
                <div className="flex items-center h-[88px] px-8">
                    <BackIcon
                        onClick={() => history.back()}
                        className="cursor-pointer mr-6 fill-gray-500 hover:fill-gray-900 transition-colors"
                    />
                    <div className="flex shrink-0 mr-3 justify-center items-center w-10 h-10 rounded-full bg-indigo-50">
                        <SitesIcon className="stroke-indigo-500" />
                    </div>
                    <span className="text-2xl font-semibold mr-3">{site?.name}</span>
                </div>
                <section className="px-8 py-6 h-[88px]">
                    <Tabs
                        tabs={[
                            {
                                name: 'Details',
                                href: 'details',
                                current: tab === 'details',
                                disabled: true,
                            },
                            {
                                name: 'Staff',
                                href: 'staff',
                                current: tab === 'staff',
                            },
                            {
                                name: 'Sites',
                                href: 'sites',
                                current: tab === 'sites',
                                disabled: true,
                            },
                            {
                                name: 'Studies',
                                href: 'statistics',
                                current: tab === 'statistics',
                                disabled: true,
                            },
                            {
                                name: 'Events',
                                href: 'events',
                                disabled: true,
                                current: tab === 'events',
                            },
                        ]}
                    />
                </section>
            </section>
            <section>
                <Outlet />
            </section>
        </section>
    )
}
